import urlJoin from "url-join";

export const wsmSeriesSectionUrlName = "/wsm/product-series";

export const wsmSeriesListPath = `${wsmSeriesSectionUrlName}/`;
export const wsmSeriesAddPath = urlJoin(wsmSeriesListPath, "add");
export const wsmSeriesPath = (id: string) => urlJoin(wsmSeriesListPath, id);
export const wsmSeriesUrl = (id: string) => wsmSeriesPath(encodeURIComponent(id));
